module.exports = __webpack_public_path__ + "static/media/bus2x.38fc46a5.png";